import { fetchWrapper } from 'app/_helpers/fetch-wrapper';

const WMSOutbondURL = process.env.REACT_APP_API_WMSOUTBOUND_URL;
const baseUrl = `${WMSOutbondURL}order`;
export const OrderService = {
    getAll,
    getById,
    create,
    createFormData,
    updateFormData,
    getByIdOrderStatusId,
    updateOrderStatusAllocated,
    updateOrderStatusApprove,
    update,
    delete: _delete,
    getOrderApprovalRequests,
    orderApproval,
    getAllNew,
    deleteOrder,
};

function getAll(clientId) {
    return fetchWrapper.get(`${baseUrl}/client/${clientId}`);
}

function getByIdOrderStatusId(id) {
    return fetchWrapper.get(`${baseUrl}/status-id?id=${id}`);
}
function getById(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`);
}

function create(params) {
    return fetchWrapper.post(baseUrl, params);
}

function createFormData(params) {
    return fetchWrapper.post(`${baseUrl}/upload/create-master`, params);
}
function updateFormData(params, id) {
    return fetchWrapper.put(`${baseUrl}/upload/create-master/${id}`, params);
}
function updateOrderStatusApprove(id) {
    return fetchWrapper.put(`${baseUrl}/reviewedAndApproved/${id}`);
}
function updateOrderStatusAllocated(id) {
    return fetchWrapper.put(`${baseUrl}/allocate/${id}`);
}

function update(id, params) {
    return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(id) {
    return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function getOrderApprovalRequests() {
    return fetchWrapper.get(`${baseUrl}/approval/pending`);
}

function orderApproval(params) {
    return fetchWrapper.post(`${baseUrl}/outward/approval`, params);
}

function getAllNew(clientId) {
    return fetchWrapper.get(`${baseUrl}/fetchSpecificClientOutward/${clientId}`);
}

function deleteOrder(id) {
    return fetchWrapper.put(`${baseUrl}/cp/${id}/cancellation`);
}